import React, { Component } from 'react';

class SocialIcon extends Component {
  render() {
    return (
      <div className="login-social-auth d-flex">
        {/* <a href="/" className="authentication d-flex align-items-center">
          <img src={require("../../assets/svg/facebook.svg")} alt=""/>
        </a>
        <a href="/" className="authentication d-flex align-items-center">
          <img src={require("../../assets/svg/twitter.svg")} alt=""/>
        </a>
        <a href="/" className="authentication d-flex align-items-center">
          <img src={require("../../assets/svg/linkedin.svg")} alt=""/>
        </a> */}
      </div>
    );
  }
}
export default SocialIcon;
